import axios from 'axios';
import Vue from 'vue'

export default {
    getEventLog(page, pageSize, start, end, customerId, adminEventLog) {
        return axios.get('/api/event-log/list', { params: {page:page,pageSize:pageSize, start:start, end:end, customerId:customerId, adminEventLog:adminEventLog } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}